/**
 * A time to the hundredth ("45.55s", "1:09.85"), as a stopwatch shows it. Ticks are sixtieths, so
 * two different times never look the same (owner, 2026-10-30: 45.500 and 45.550 both showed as
 * 45.5s on the Daily board and read as a tie).
 */
export const formatTime = (ticks: number, tickRate: number): string =>
  stopwatch(ticks, tickRate, 2);

/** The running clock in a lawn's HUD, to the tenth (hundredths would flicker). */
export const formatClock = (ticks: number, tickRate: number): string =>
  stopwatch(ticks, tickRate, 1);

function stopwatch(ticks: number, tickRate: number, places: 1 | 2): string {
  const unit = 10 ** places;
  // Whole units first, so no float rounding can show 59.99 as 60.0.
  const n = Math.floor((ticks * unit) / tickRate);
  const m = Math.floor(n / (60 * unit));
  const rest = n - m * 60 * unit;
  const s = `${Math.floor(rest / unit)}.${String(rest % unit).padStart(places, '0')}`;
  return m > 0 ? `${m}:${s.padStart(3 + places, '0')}` : `${s}s`;
}
